import { useState } from "react";
import ProjectAccordion from "./projectAccordion";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRightIcon } from "@heroicons/react/24/solid";

const CountryAccordion = ({ countries, title, click, open }) => {
  const [isOpen, setIsOpen] = useState(null);
  return (
    <div>
      <button
        onClick={click}
        className="group text-visBlue flex w-full items-center justify-between gap-3 border p-5"
      >
        <p className="text-start text-xl font-semibold transition-all group-hover:text-visOrange">
          {title}
        </p>
        <motion.div
          initial={false}
          animate={{ rotate: open ? 90 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <ChevronRightIcon
            className={`${open && "text-visOrange"} h-6 w-6 font-thin transition-all group-hover:text-visOrange`}
          />
        </motion.div>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, marginTop: "0rem" }}
            animate={{ height: "auto", marginTop: "0.0rem" }}
            exit={{ height: 0, marginTop: "0rem" }}
            transition={{ duration: 0.3, ease: "linear" }}
            className="overflow-x-auto bg-white"
          >
            {countries.map((country, index) => {
              return (
                <div key={index} className="border even:bg-visLightGray">
                  <ProjectAccordion
                    isOpen={isOpen === index}
                    onClick={() => setIsOpen(isOpen === index ? null : index)}
                    title={country.name}
                    projects={country.projects}
                  />
                </div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CountryAccordion;
